module.exports = __webpack_public_path__ + "static/media/loadingBlack.9b97f39c.gif";